import { ShiftViewModel } from '@/models'

export function filterShiftsByDepartments(
    shifts: ShiftViewModel[],
    departments: string[],
): ShiftViewModel[] {
    return shifts.filter(shift => !! departments
        .find(department => department === shift?.department?.id))
}
